module.exports = __webpack_public_path__ + "static/media/icon.52f88ac3.svg";